import React from 'react';
import { Download, FileText, ChevronRight } from 'lucide-react';
import { Report } from './ReportCard';
import { API_URL } from '../../config';

interface MobileReportListItemProps {
    report: Report;
    onView: () => void;
    onDownload: () => void;
}

const MobileReportListItem: React.FC<MobileReportListItemProps> = ({ report, onView, onDownload }) => {

    const getReportIconColor = (type: string) => {
        switch (type) {
            case 'DAILY': return '#3b82f6';
            case 'WEEKLY': return '#8b5cf6';
            case 'MONTHLY': return '#f59e0b';
            case 'QUARTERLY': return '#10b981';
            default: return '#64748b';
        }
    };

    const getReportLabel = (type: string) => {
        switch (type) {
            case 'DAILY': return 'Flash';
            case 'WEEKLY': return 'Hebdo';
            case 'MONTHLY': return 'Mensuel';
            case 'QUARTERLY': return 'Trim.';
            default: return 'Autre';
        }
    };

    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                padding: '16px',
                background: 'var(--bg-box)',
                borderRadius: '16px',
                border: '1px solid var(--border-color)',
                boxShadow: '0 2px 8px -4px rgba(0,0,0,0.05)',
                transition: 'transform 0.1s active',
                cursor: 'pointer',
                touchAction: 'manipulation'
            }}
            onClick={onView}
        >
            {/* Left Icon / Thumbnail */}
            <div style={{
                width: '48px',
                height: '48px',
                borderRadius: '12px',
                background: `${getReportIconColor(report.report_type)}15`,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
                marginRight: '16px',
                border: `1px solid ${getReportIconColor(report.report_type)}30`
            }}>
                <FileText size={24} color={getReportIconColor(report.report_type)} />
            </div>

            {/* Center Content */}
            <div style={{ flex: 1, minWidth: 0, paddingRight: '12px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '4px' }}>
                    <span style={{
                        fontSize: '10px',
                        fontWeight: '700',
                        color: getReportIconColor(report.report_type),
                        background: `${getReportIconColor(report.report_type)}15`,
                        padding: '2px 6px',
                        borderRadius: '4px',
                        textTransform: 'uppercase'
                    }}>
                        {getReportLabel(report.report_type)}
                    </span>
                    <span style={{ fontSize: '11px', color: 'var(--text-muted)' }}>
                        {new Date(report.publication_date).toLocaleDateString('fr-FR', { day: '2-digit', month: 'short' })}
                    </span>
                </div>

                <h4 style={{
                    margin: 0,
                    fontSize: '14px',
                    fontWeight: '600',
                    color: 'var(--text-heading)',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis'
                }}>
                    {report.title}
                </h4>
            </div>

            {/* Right Actions */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                {/* Download Button */}
                <button
                    onClick={(e) => {
                        e.stopPropagation();
                        onDownload();
                    }}
                    style={{
                        background: 'var(--bg-hover)',
                        border: '1px solid var(--border-color)',
                        width: '36px',
                        height: '36px',
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        cursor: 'pointer'
                    }}
                >
                    <Download size={16} color="var(--text-main)" />
                </button>
                <ChevronRight size={18} color="var(--text-muted)" style={{ opacity: 0.5 }} />
            </div>
        </div>
    );
};

export default MobileReportListItem;
